var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wGC-categoryArea"},[_c('div',{staticClass:"wGC-head"},[_c('div',{staticClass:"wGCH-column"},[_c('h2',[_vm._v("分账管理")])])]),_c('div',{staticClass:"wGC-categoryList"},[_c('div',{staticClass:"wGLG-table"},[_c('p',{staticStyle:{"padding":"20px","color":"#666"}},[_vm._v("分账功能开发中...")])])])])])
}]

export { render, staticRenderFns }